import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import PortalTypes from 'Lib/constants/app/portalTypes';

import Carousel from './Carousel';
import CarouselControls from './CarouselControls';
import Thumbnails from './Thumbnails';
import { createFileSlides, createItems, createThumbnails } from './utils';

// This is not ready for use in portals than manager. It only handles api structure from manager portal.

/**
 * Renders a carousel component for displaying files.
 * @typedef {Object} FileCarouselProps
 * @param {FileParent[]} files - The array of files to be displayed in the carousel.
 * @param {number} currentIndex - The index of the active file in the carousel.
 * @returns {JSX.Element} The rendered carousel component.
 */
export default function FileCarousel({ files, objectID, objectTypeID, portalID, currentIndex, onFileChange }) {
    // get the portalTypeID from redux
    const portalTypeID = useSelector(state => state.app.portalTypeID);
    const portalType = PortalTypes.getName(portalTypeID).toLowerCase();
    const leaseID = useSelector(state => state.app.lease?.lease?.leaseID);
    const portfolioID = useSelector(state => state.app.portfolio?.portfolioID);

    const items = useMemo(() => createItems(files, portalType, objectID, objectTypeID, portalID, leaseID, portfolioID), [files]);
    const slides = useMemo(() => createFileSlides(items), [items]);
    const thumbnails = useMemo(() => createThumbnails(items), [items]);

    // Call onFileChange when onImageChange is called
    const onMediaChange = index => {
        if (onFileChange) onFileChange(files.files[index]);
    };

    return (
        <Carousel slides={slides} activeIndex={currentIndex} onMediaChange={onMediaChange}>
            <CarouselControls />
            <Thumbnails thumbnails={thumbnails} />
        </Carousel>
    );
}
